const Form = () => {
  return (
    <div className="w-full lg:max-w-md max-w-lg mx-auto lg:ml-auto">
      <div className="bg-white rounded-[28px] p-6 md:p-8 shadow-2xl xl:w-[503px] xl:h-[533px]">
        <h3 className="text-2xl font-medium text-gray-900 mb-6">
          Request a Sourcing Quote
        </h3>

        <form className="space-y-4">
          {/* Row 1: Name & Email */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-xs font-medium text-gray-500 mb-1">
                Full Name
              </label>
              <input
                type="text"
                placeholder="Ex: John Doe"
                className="bg-gray-100 border border-transparent focus:border-gray-300 rounded px-3 py-2 text-sm outline-none transition-all"
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-medium text-gray-500 mb-1">
                Email
              </label>
              <input
                type="email"
                placeholder="john@company.com"
                className="bg-gray-100 border border-transparent focus:border-gray-300 rounded px-3 py-2 text-sm outline-none transition-all"
              />
            </div>
          </div>

          {/* Row 2: Company & Category */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-xs font-medium text-gray-500 mb-1">
                Company Name
              </label>
              <input
                type="text"
                placeholder="Acme Corp"
                className="bg-gray-100 border border-transparent focus:border-gray-300 rounded px-3 py-2 text-sm outline-none transition-all"
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-medium text-gray-500 mb-1">
                Interested Category (optional)
              </label>
              <div className="relative">
                <select className="w-full bg-gray-100 border border-transparent focus:border-gray-300 rounded px-3 py-2 text-sm outline-none appearance-none cursor-pointer">
                  <option>General Inquiry</option>
                  <option>Apparel</option>
                  <option>Electronics</option>
                </select>
                {/* Custom Arrow Icon for Select */}
                <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none text-gray-500">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Row 3: Requirement Details */}
          <div className="flex flex-col">
            <label className="text-xs font-medium text-gray-500 mb-1">
              Requirement Details
            </label>
            <textarea
              rows="4"
              placeholder="Specify quantities, materials, or customization needs..."
              className="bg-gray-100 border border-transparent focus:border-gray-300 rounded px-3 py-2 text-sm outline-none resize-none transition-all"
            ></textarea>
          </div>

          {/* Submit Button */}
          <button
            type="button"
            className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-3 flex items-center justify-center gap-2 transition-colors mt-2"
          >
            <svg
              className="w-4 h-4 transform -rotate-45 mb-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
              />
            </svg>
            Send Inquiry
          </button>

          {/* Privacy Text */}
          <p className="text-[10px] text-gray-400 text-center mt-2">
            By submitting this form, you agree to our{" "}
            <a href="#" className="underline text-black font-semibold">
              privacy policy
            </a>
            . We respect your inbox.
          </p>
        </form>
      </div>
    </div>
  );
};

export default Form;
